// ---------------------------------------------------------------------------
// Shared upper bound for files read whole into memory as a single buffer
// (.ehd, shapefile .shp/.dbf, GeoJSON/.json) before any parsing is
// attempted — real projects are nowhere near this (a real .ehd is a few MB
// at most; the biggest real shapefile seen so far is well under 10 MB), so
// this exists purely to fail fast with a clear message instead of the tab
// hanging/crashing on a corrupt or accidentally-wrong file. Input SERIES
// (Ent_Precip.csv and similar) are NOT covered here — those are read a
// column at a time by csvWorker.ts and a real project's is already
// documented as 17-25 MB (see dailySeries.ts's own header), so the same bound
// wouldn't make sense there.
// ---------------------------------------------------------------------------

const MAX_IMPORT_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export function exceedsMaxImportSize(file: { size: number }): boolean {
  return file.size > MAX_IMPORT_FILE_SIZE_BYTES;
}
